<!-- Buscador -->
<div class="mb-4">
  <label class="block text-sm font-semibold text-gray-700 mb-2"> Buscar por Código o Nombre </label>
  <div class="flex items-center gap-2">
    <div class="flex-1">
      <app-input-buscador
        #inputBuscador
        [(valor)]="searchTerm"
        [placeholder]="'Ingresa código o nombre del producto...'"
        (presionaEnter)="buscarProducto()"
      />
    </div>
    @if (puedeEscanearConCamara) {
      <button
        type="button"
        (click)="abrirEscaner()"
        class="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-accent-600 text-white shadow-sm transition-transform active:scale-95"
        aria-label="Escanear producto con la cámara"
      >
        <i class="bi bi-upc-scan text-xl"></i>
      </button>
    }
  </div>
  @if (puedeEscanearConCamara) {
    <p class="mt-1 text-xs text-gray-400">
      Escanea el código para agregar stock; si no existe, podrás crearlo con ese código.
    </p>
  }
</div>
<!-- Tabla de productos seleccionados -->
<app-tabla
  [columnas]="columnasTabla"
  [accionesTemplate]="accionesTemplate"
  [datos]="productosSeleccionados()"
/>

<!-- Descripción general del ingreso -->
<div class="mb-4 bg-gray-50 rounded-lg p-4 border border-gray-200">
  <div class="flex items-center gap-2 mb-3">
    <label class="text-sm font-semibold text-gray-700">Descripción del ingreso</label>
    <label class="inline-flex items-center gap-1.5 cursor-pointer ml-auto">
      <input
        type="checkbox"
        class="w-4 h-4 text-blue-600 rounded border-gray-300 focus:ring-blue-500"
        [checked]="usarDescripcionGeneral()"
        (change)="usarDescripcionGeneral.set(!usarDescripcionGeneral())"
      />
      <span class="text-xs text-gray-500">Misma descripción para todos</span>
    </label>
  </div>

  @if (usarDescripcionGeneral()) {
    <input
      type="text"
      class="w-full border rounded px-3 py-2 text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
      placeholder="Ej: Compra semanal a proveedor, reposición de almacén..."
      [ngModel]="descripcionGeneral()"
      (ngModelChange)="descripcionGeneral.set($event)"
    />
  } @else {
    <p class="text-xs text-gray-400">
      Asigna una descripción individual a cada producto en la tabla.
    </p>
  }
</div>

<ng-template #cantidadTemplate let-producto>
  <input
    type="number"
    min="1"
    class="w-20 border rounded px-2 py-1 text-sm"
    [(ngModel)]="producto.cantidad"
  />
</ng-template>

<ng-template #descripcionTemplate let-producto>
  @if (!usarDescripcionGeneral()) {
    <input
      type="text"
      class="w-full border rounded px-2 py-1 text-xs"
      placeholder="Descripción..."
      [(ngModel)]="producto.descripcion_ingreso"
    />
  } @else {
    <span class="text-xs text-gray-400 italic">{{
      descripcionGeneral() || 'Sin descripción'
    }}</span>
  }
</ng-template>

<ng-template #accionesTemplate let-producto>
  <button
    class="text-red-600 hover:text-red-800 font-medium"
    (click)="eliminarProducto(producto.id)"
    type="button"
  >
    Quitar
  </button>
</ng-template>

<!-- botones para registrar o limpiar los productos para el inventario -->
<div class="mt-6 flex justify-center gap-4">
  <button
    class="bg-green-600 text-white px-4 py-2 rounded hover:bg-green-700 disabled:opacity-50"
    (click)="modal_confirmacion_registro.set(true)"
    [disabled]="productosSeleccionados().length === 0"
    type="button"
  >
    Registrar Productos en Inventario
  </button>
  <button
    class="bg-gray-600 text-white px-4 py-2 rounded hover:bg-gray-700 disabled:opacity-50"
    (click)="limpiarSeleccion()"
    [disabled]="productosSeleccionados().length === 0"
    type="button"
  >
    Limpiar Selección
  </button>

  <!-- mostrar las sugerencias de productos para seleccionar -->
  <app-dialog
    header="Seleccionar Producto"
    [modal]="true"
    [(visible)]="modal_producto_sugerencias"
    (onHide)="onCloseModalProductoSugerencias()"
    size="lg"
  >
    @if (sugerenciasProductos().length > 0) {
      <ul class="divide-y divide-gray-200 max-h-80 overflow-y-auto w-96">
        @for (producto of sugerenciasProductos(); track producto.id) {
          <li class="py-2 flex justify-between items-center">
            <div>
              <p class="font-medium">{{ producto.nombre }}</p>
              <p class="text-sm text-gray-500">{{ producto.codigo }}</p>
            </div>
            <small> {{ producto.precio_venta | currency: 'PEN' : 'S/. ' }} </small>
            <button
              class="bg-blue-600 text-white px-3 py-1 rounded hover:bg-blue-700"
              (click)="agregarProducto(producto)"
            >
              Agregar
            </button>
          </li>
        } @empty {
          <p class="text-gray-500">No se encontraron productos.</p>
        }
      </ul>
    }
  </app-dialog>
</div>

<!-- confirmacion de agregado -->
<app-dialog
  header="Confirmar Registro"
  [modal]="true"
  [(visible)]="modal_confirmacion_registro"
  (onHide)="modal_confirmacion_registro.set(false)"
  size="xs"
>
  <app-modal-confirmacion
    [mensaje]="'¿Estás seguro que desea ingresar estos productos al inventario?'"
    [textoConfirm]="'Sí, Registrar'"
    [textoCancel]="'No, Cancelar'"
    (confirmar)="registrarProductosInventario()"
    (cancelar)="modal_confirmacion_registro.set(false)"
  />
</app-dialog>

<!-- escáner de cámara -->
@if (scannerAbierto()) {
  <app-escaner-codigo
    titulo="Escanear para inventario"
    subtitulo="Si el producto no existe, se abrirá el formulario de creación"
    (codigoDetectado)="onCodigoEscaneado($event)"
    (cerrar)="cerrarEscaner()"
  />
}

<!-- crear producto cuando el código escaneado no existe -->
<app-dialog
  header="Crear producto"
  [modal]="true"
  [(visible)]="modal_crear_producto"
  (onHide)="cerrarCrearProducto()"
  size="md"
>
  @if (modal_crear_producto()) {
    <app-crear-producto
      [categorias]="categorias()"
      [codigoInicial]="codigoEscaneado()"
      [crearConStockCero]="true"
      (stockInicial)="onStockInicialCreado($event)"
      (crear)="onProductoCreado($event)"
    />
  }
</app-dialog>
